@if (cpdEntry) {
  <div>
    @if (cpdEntry.currentReviewerAnnotation) {
      <div class="annotation">
        <h5>Your annotation</h5>
        <p>
          {{cpdEntry.currentReviewerAnnotation}}
        </p>
      </div>
    }
    @if (cpdEntry.otherReviewerAnnotation) {
      <div  class="annotation">
        <h5>Peer's annotation</h5>
        <p>
          {{cpdEntry.otherReviewerAnnotation}}
        </p>
      </div>
    }
  </div>
}